var detect = require('./detect');

module.exports = {
    createEvent: function(name) {
        if (detect.hasEventConstructor()) {
            return new window.Event(name);
        } else {
            var event = document.createEvent('Event');
            event.initEvent(name, true, false);
            return event;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mini-router/lib/event.js
// module id = 378
// module chunks = 0